export default (() => {
  const ja = {
    minute: '分',
    about: '約',
    stay: '滞在',
    detail: '詳細',
    departure: '出発',

    // SpotItems 用
    detailView: '詳細を見る',
    editOnMap: 'このコースを地図で確認・編集する',
  };

  const en = {
    minute: 'min',
    about: 'about',
    stay: 'stay',
    detail: 'detail',
    departure: 'departure',

    detailView: 'View details',
    editOnMap: 'Check / Edit this course on the map',
  };

  const zh_cn = {
    minute: '分钟',
    about: '关于',
    stay: '停留',
    detail: '细节',
    departure: '离开',

    detailView: '查看详情',
    editOnMap: '在地图上查看／编辑此行程',
  };

  const zh_tw = {
    minute: '分鐘',
    about: '約',
    stay: '停留',
    detail: '細節',
    departure: '出發',

    detailView: '查看詳細',
    editOnMap: '在地圖上查看／編輯此行程',
  };

  const kr = {
    minute: '분',
    about: '에 대한',
    stay: '머무르다',
    detail: '세부 사항',
    departure: '출발',

    detailView: '자세히 보기',
    editOnMap: '지도로 이 코스를 확인／편집',
  };

  // ★ ここが追加：タイ語
  const th = {
    minute: 'นาที',
    about: 'ประมาณ',
    stay: 'ใช้เวลา',
    detail: 'รายละเอียด',
    departure: 'ออกเดินทาง',

    detailView: 'ดูรายละเอียด',
    editOnMap: 'ดู / แก้ไขคอร์สนี้บนแผนที่',
  };

  return {
    ja,
    jp: ja,
    en,
    en_US: en,
    zh_cn,
    'zh-cn': zh_cn,
    zh_CN: zh_cn,
    'zh-hans': zh_cn,
    zh_tw,
    'zh-tw': zh_tw,
    zh_TW: zh_tw,
    'zh-hant': zh_tw,
    kr,
    ko: kr,
    // ★ タイ語を登録
    th,
    th_TH: th,
  };
})();
